export default __webpack_public_path__ + "static/media/Feature_Banner_X_2.31d88ba7.png";